import { FormatDateProps } from './FormatDate.types'

export const FormatDate = (props: FormatDateProps) => {
  const { value, shouldShowTime } = props

  if (!value) {
    return null
  }

  const date = value instanceof Date ? value : new Date(value)
  const preferredLanguage = navigator.languages[0] || window.navigator.language
  const formattedDate = new Intl.DateTimeFormat(preferredLanguage).format(date)

  if (shouldShowTime) {
    const formattedTime = new Intl.DateTimeFormat(preferredLanguage, {
      timeStyle: 'short',
    }).format(date)

    return <div>{`${formattedDate}, ${formattedTime}`}</div>
  }

  return <div>{formattedDate}</div>
}
